import { GENERAL_VARIABLE_DATA } from '../general/general.data';
import { QuestionnaireActiveData } from './active.interface';

export const QUESTIONNAIRE_ACTIVE_DATA: QuestionnaireActiveData = {
  fitnessGoals: {
    title: 'Fitness Goal',
    fieldName: 'fitnessGoals',
    options: [
      {
        id: '1',
        name: 'None',
        value: 'None'
      },
      {
        id: '2',
        name: 'Increase Strength',
        value: 'Increase Strength',
        isDefault: true
      },
      {
        id: '3',
        name: 'Maintain Strength',
        value: 'Maintain Strength'
      },
      {
        id: '4',
        name: 'Increase Endurance/Cardiovascular',
        value: 'Increase Endurance/Cardiovascular'
      },
      {
        id: '5',
        name: 'Maintain Endurance/Cardiovascular',
        value: 'Maintain Endurance/Cardiovascular'
      },
      {
        id: '6',
        name: 'Increase Flexibility',
        value: 'Increase Flexibility'
      },
      {
        id: '7',
        name: 'Maintain Flexibility',
        value: 'Maintain Flexibility'
      },
      {
        id: '8',
        name: 'Increase Mobility/Agility',
        value: 'Increase Mobility/Agility'
      },
      {
        id: '9',
        name: 'Maintain Mobility/Agility',
        value: 'Maintain Mobility/Agility'
      }
    ]
  },
  'exerciseCurrentDetails.exerciseTimesPerWeek': {
    title: 'Exercise Time per Week',
    fieldName: 'exerciseCurrentDetails.exerciseTimesPerWeek',
    showOtherInput: true,
    placeholderOther: 'Other Exercise Time per Week',
    options: [
      {
        id: '1',
        name: '1 time per week',
        value: '1 time per week',
        metCalculation: 1
      },
      {
        id: '2',
        name: '2 time per week',
        value: '2 time per week',
        metCalculation: 2
      },
      {
        id: '3',
        name: '3 time per week',
        value: '3 time per week',
        metCalculation: 3,
        isDefault: true
      },
      {
        id: '4',
        name: '4 time per week',
        value: '4 time per week',
        metCalculation: 4
      },
      {
        id: '5',
        name: '5 time per week',
        value: '5 time per week',
        metCalculation: 5
      },
      {
        id: '6',
        name: '6 time per week',
        value: '6 time per week',
        metCalculation: 6
      },
      {
        id: '7',
        name: '7 time per week',
        value: '7 time per week',
        metCalculation: 7
      }
    ]
  },
  'exerciseCurrentDetails.exerciseMinutesPerSession': {
    title: 'Exercise Minutes per Session',
    fieldName: 'exerciseCurrentDetails.exerciseMinutesPerSession',
    options: [
      {
        id: '1',
        name: 'Less than 20 minutes',
        metCalculation: 1,
        value: 'Less than 20 minutes',
        isDefault: true
      },
      {
        id: '2',
        name: '20-40 minutes',
        metCalculation: 2,
        value: '20-40 minutes'
      },
      {
        id: '3',
        name: '40-60 minutes',
        metCalculation: 3,
        value: '40-60 minutes'
      },
      {
        id: '4',
        name: 'More than 60 minutes',
        metCalculation: 4,
        value: 'More than 60 minutes'
      }
    ]
  },
  'exerciseCurrentDetails.exerciseCurrently': {
    title: 'Exercise Type',
    fieldName: 'exerciseCurrentDetails.exerciseCurrently',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Exercise Type',
    options: [
      {
        id: '1',
        name: 'Walking',
        description: '(e.g., casual walking)',
        value: 'Walking',
        isDefault: true
      },
      { id: '2', name: 'Running/Jogging', value: 'Running/Jogging' },
      {
        id: '3',
        name: 'Cycling (leisure or competitive)',
        value: 'Cycling (leisure or competitive)'
      },
      { id: '4', name: 'Swimming', value: 'Swimming' },
      {
        id: '5',
        name: 'Weightlifting or Resistance training',
        value: 'Weightlifting or Resistance training'
      },
      { id: '6', name: 'Yoga or Pilates', value: 'Yoga or Pilates' },
      {
        id: '7',
        name: 'High-Intensity Interval Training (HIIT)',
        value: 'High-Intensity Interval Training (HIIT)'
      },
      {
        id: '8',
        name: 'Team Sports',
        description: '(e.g., soccer, basketball)',
        value: 'Team Sports'
      },
      { id: '9', name: 'Calisthenic Workout', value: 'Calisthenic Workout' }
    ]
  },
  injuryHistory: {
    title: 'Injury History',
    fieldName: 'injuryHistory',
    showOtherInput: true,
    placeholderOther: 'Other Injury History',
    options: [
      { id: '1', name: 'No injuries', value: 'No injuries', isDefault: true },
      { id: '2', name: 'Neck injury', value: 'Neck injury' },
      { id: '3', name: 'Back injury', value: 'Back injury' },
      { id: '4', name: 'Knee injury', value: 'Knee injury' },
      { id: '5', name: 'Shoulder injury', value: 'Shoulder injury' }
    ]
  },
  medicalHistory: {
    title: 'Medical History',
    fieldName: 'medicalHistory',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Medical History',
    options: (GENERAL_VARIABLE_DATA.healthMedicalHistories?.options ?? [])
      .filter(
        (i) =>
          (i.isDefault === false &&
            i.isContagious === false &&
            ['ILLNESS', 'DISEASE'].every((type) => i.type?.includes(type)) &&
            ['FATHER', 'MOTHER'].every((parent) =>
              i.applicableParent?.includes(parent)
            )) ||
          i.isDefault === true
      )
      .map((option, index) => ({
        ...option,
        id: `${index + 1}`
      }))
  }
};
